import { getURLParams } from 'src/helpers/actions/local/core/local_action_parse_url_helpers';
import { isValidRGB } from 'src/helpers/actions/local/ui/lights_local_actions_view';
//Types
import type { ActionJob } from 'src/types/requests/schedules/schedules_g2';

export const validateCuryURLWebhook = (url: string): ActionJob | null => {
	const action: ActionJob = getURLParams(url);
	if (action.method === 'cury.setconfig') {
		const ambient = action.params?.config?.ambient;
		action.error =
			action.error ||
			!ambient ||
			(ambient?.brightness != null && (ambient.brightness < 0 || ambient.brightness > 100)) ||
			(Array.isArray(ambient?.color) && !isValidRGB(ambient.color));
	} else if (action.method === 'cury.set' && action.params?.intensity != null) {
		const intensity = action.params.intensity;
		action.error = action.error || intensity < 0 || intensity > 100;
	}
	if (/^cury.(set|boost)$/.test(action.method)) {
		action.error = action.error || !/^(left|right)$/.test(action.params?.slot);
	}
	return action;
};
